// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__oNlUP","info-box":"Contact_info-box__HPkCF"};